<template>
  <div>
    <slot :data="dataInView"></slot>
    <div id="show-more-or-less" class="text-center">
      <span v-if="hasMoreData" @click="isOpen = !isOpen" class="clickable capitalize color-evollu">
        <span>{{isOpen ? $t('show_partial_or_full_list.less') : $t('show_partial_or_full_list.all', {count: data.length})}}</span>
        &nbsp;
        <i class="fa" :class="{'fa-chevron-up': isOpen, 'fa-chevron-down': !isOpen}"></i>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pageLimit: {
      type: Number,
      required: false,
      default: 25
    },
    data: {
      type: Array,
      required: true
    }
  },
  computed: {
    hasMoreData: function () {
      return this.data.length > this.pageLimit
    },
    dataInView: function () {
      return this.isOpen ? this.data : this.data.slice(0, this.pageLimit - 1)
    },
  },
  data: function () {
    return {
      isOpen: false
    }
  }
}
</script>
